import React, { useEffect, useState } from 'react';
import { Icon } from './Icon';

export const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check local storage or system preference on initial load
    const savedTheme = localStorage.getItem('calc-pro-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleTheme = () => {
    if (isDark) {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('calc-pro-theme', 'light');
      setIsDark(false);
    } else {
      document.documentElement.classList.add('dark');
      localStorage.setItem('calc-pro-theme', 'dark');
      setIsDark(true);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <span className={`text-[10px] font-black uppercase tracking-wider transition-colors ${!isDark ? 'text-indigo-600' : 'text-slate-500'}`}>
        Claro
      </span>

      <button
        onClick={toggleTheme}
        className="relative w-14 h-7 rounded-full p-1 transition-all duration-300 bg-slate-200 dark:bg-slate-800 border border-slate-300 dark:border-white/10 group overflow-hidden"
        aria-label="Alternar Tema"
      >
        {/* Sliding Thumb */}
        <div className={`absolute top-1 left-1 w-5 h-5 rounded-full transition-all duration-500 transform flex items-center justify-center shadow-lg ${isDark ? 'translate-x-7 bg-emerald-500 shadow-emerald-500/40' : 'bg-white shadow-indigo-500/20'}`}>
          {isDark ? (
            <Icon name="sun" className="w-3.5 h-3.5 text-white" />
          ) : (
            <Icon name="moon" className="w-3.5 h-3.5 text-indigo-600" />
          )}
        </div>
      </button>

      <span className={`text-[10px] font-black uppercase tracking-wider transition-colors ${isDark ? 'text-emerald-500' : 'text-slate-500'}`}>
        Escuro
      </span>
    </div>
  );
};
